<template>
  <apexchart
    :key="reRenderKey"
    :width="chartWidth"
    height="100%"
    :options="lineChartOptions()"
    :series="chartSeries"
  />
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class extends Vue {
  @Prop({ required: true }) private chartSeries!: Array<number>
  @Prop({ required: true }) private chartWidth!: number
  @Prop({ required: true }) private initialDateRange!: number

  private reRenderKey = 0

  private en = require('apexcharts/dist/locales/en.json')
  private fr = require('apexcharts/dist/locales/fr.json')

  private lineChartOptions() {
    return {
      chart: {
        type: 'line',
        locales: [this.en, this.fr],
        defaultLocale: this.$i18n.locale,
        events: {
          beforeZoom: function(ctx: any) {
            ctx.w.config.xaxis.range = undefined
          }
        },
        toolbar: {
          tools: {
            download: false,
            reset: false
          }
        }
      },
      colors: ['hsl(190, 100%, 50%)'],
      stroke: {
        show: true,
        curve: 'smooth',
        width: 4
      },
      markers: {
        size: 6,
        strokeColors: 'hsl(0, 100%, 100%)',
        strokeWidth: 3,
        strokeOpacity: 0.8
      },
      xaxis: {
        type: 'datetime',
        tooltip: {
          enabled: false
        },
        range: this.initialDateRange
      }
    }
  }

  @Watch('$i18n.locale')
  private languageChanged() {
    this.reRenderKey += 1
  }
}
</script>
